import { render, staticRenderFns } from "./HelpFifthPage.vue?vue&type=template&id=66560ab7&"
import script from "./HelpFifthPage.vue?vue&type=script&lang=js&"
export * from "./HelpFifthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports